import d3Legacy from 'd3-legacy';
import _floor from 'lodash/floor';
import _toInteger from 'lodash/toInteger';
import { getIsMobileWidth, getIsPhabletWidth } from 'js/store/actions/device';
import clearNodeChildren from 'js/helpers/clearNodeChildren';
import SHARED_STYLES from 'json/shared_styles.json';
var X_AXIS_LABEL_X = 10;
var X_AXIS_LABEL_Y = 18;
var Y_AXIS_LABEL_X = 10;
var Y_AXIS_LABEL_Y = -10;
var TOOLTIP_X_MARGIN = 25;
var TOOLTIP_Y_MARGIN = 25;
var TOOLTIP_SIDE_PADDING = 9;
var TOOLTIP_TOP_BOTTOM_PADDING = 7;
var DOT_RADIUS_NORMAL = 3.5;
var DOT_RADIUS_ENLARGED = 10;
export var initializePlot = function initializePlot(ctx, props) {
  var data = props.data;
  clearNodeChildren(document.getElementById(ctx.props.plotID));
  var dataKeys = Object.keys(data[0]).filter(function (key) {
    return key.indexOf('_pred') === -1 && ['label', 'datetime'].indexOf(key) === -1;
  });
  dataKeys.forEach(function (key) {
    renderScatterPlot(ctx, key, "".concat(key, "_pred"), data, 'MW', 'MW');
  });
};

var renderScatterPlot = function renderScatterPlot(ctx, xValueKey, yValueKey, data, xAxisLabel, yAxisLabel) {
  var margin = {
    top: 20,
    right: 35,
    bottom: 30,
    left: 40
  };

  var graphWidth = _floor(document.getElementById(ctx.props.plotID).offsetWidth);

  var width = _floor(graphWidth / (getIsMobileWidth() ? 1 : getIsPhabletWidth() ? 2 : 3)) - margin.left - margin.right - 5;
  var height = 300 - margin.top - margin.bottom;
  /*
   * value accessor - returns the value to encode for a given data object.
   * scale - maps value to a visual display encoding, such as a pixel position.
   * map function - maps from data value to display value
   * axis - sets up axis
   */
  // setup x

  var xValue = function xValue(d) {
    return d[xValueKey];
  }; // data -> value


  var xScale = d3Legacy.scale.linear().range([0, width]); // value -> display

  var xMap = function xMap(d) {
    return xScale(xValue(d));
  }; // data -> display


  var xAxis = d3Legacy.svg.axis().scale(xScale).orient('bottom').ticks(_floor(width / graphWidth * (graphWidth / 80))); // setup y

  var yValue = function yValue(d) {
    return d[yValueKey];
  }; // data -> value


  var yScale = d3Legacy.scale.linear().range([height, 0]); // value -> display

  var yMap = function yMap(d) {
    return yScale(yValue(d));
  }; // data -> display


  var yAxis = d3Legacy.svg.axis().scale(yScale).orient('left'); // setup fill color

  var fillColorForDatum = function fillColorForDatum(d) {
    if (d.label == 'Historical') {
      return '#7647a2';
    }

    return SHARED_STYLES.graphColors[0];
  }; // Change opacity for older data


  var opacityForDatum = function opacityForDatum(d) {
    if (d.label == 'Historical') {
      return 0.2;
    }

    return 0.9;
  };

  var svgWrapperId = "cndc-scatterplot-svg-wrapper-".concat(xValueKey);
  var $svgWrapper = $(['<div class="cndc-scatterplot__svg-wrapper" style="', "width:".concat(width + margin.left + margin.right, "px;"), "height:".concat(height + margin.top + margin.bottom, "px;"), '" id="', svgWrapperId, '">', '<div class="cndc-scatterplot__title">', fixLabel(xValueKey), '</div></div>'].join(''));
  $("#".concat(ctx.props.plotID)).append($svgWrapper); // add the graph canvas to the body of the webpage

  var svg = d3Legacy.select("#".concat(svgWrapperId)).append('svg').attr('class', 'cosmos-svg--with-overflow').attr('width', '100%').attr('height', '100%').append('g').attr('transform', "translate(".concat(margin.left, ",").concat(margin.top, ")")); // Crosshairs

  var xCrossHair = svg.append('line').attr('id', 'x-crosshair').attr('class', 'cosmos-crosshair').attr('display', 'none');
  var yCrossHair = svg.append('line').attr('id', 'y-crosshair').attr('class', 'cosmos-crosshair').attr('display', 'none'); // load data
  // don't want dots overlapping axis, so add in buffer to data domain

  xScale.domain([d3Legacy.min(data, xValue) - 10, d3Legacy.max(data, xValue) + 10]);
  yScale.domain([d3Legacy.min(data, yValue) - 10, d3Legacy.max(data, yValue) + 10]);
  var xDomain = xScale.domain();
  var yDomain = yScale.domain(); // x-axis

  var xAxisElement = svg.append('g').attr('class', 'cosmos-axis cosmos-axis--x').attr('transform', "translate(0,".concat(height, ")")).call(xAxis);
  xAxisElement.append('text').attr('class', 'cosmos-axis__label cosmos-axis__label--dark').attr('x', width).attr('y', -6).style('text-anchor', 'end').text(fixLabel(xValueKey));
  xAxisElement.append('text').attr('class', 'cosmos-axis__label').attr('x', width + X_AXIS_LABEL_X).attr('y', X_AXIS_LABEL_Y).style('text-anchor', 'start').text(xAxisLabel); // y-axis

  var yAxisElement = svg.append('g').attr('class', 'cosmos-axis cosmos-axis--y').call(yAxis);
  yAxisElement.append('text').attr('class', 'cosmos-axis__label cosmos-axis__label--dark').attr('transform', 'rotate(-90)').attr('y', 6).attr('dy', '.71em').style('text-anchor', 'end').text(fixLabel(yValueKey));
  yAxisElement.append('text').attr('transform', 'rotate(-90)').attr('class', 'cosmos-axis__label').attr('x', Y_AXIS_LABEL_X).attr('y', Y_AXIS_LABEL_Y).text(yAxisLabel); // draw dots

  svg.selectAll('.dot').data(data).enter().append('circle').attr('class', 'dot').attr('id', constructDotId).attr('r', DOT_RADIUS_NORMAL).attr('cx', xMap).attr('cy', yMap).style('stroke', fillColorForDatum).style('fill', fillColorForDatum).style('fill-opacity', opacityForDatum).style('stroke-opacity', 0.6).on('mouseover', onDotMouseOver).on('mouseout', onDotMouseOut); // tooltip

  var tooltipNode = svg.append('g').attr('class', 'cosmos-focus-node').attr('display', 'none');
  var tooltipNodeRect = tooltipNode.append('rect').attr('rx', '5px').attr('ry', '5px').attr('class', 'cosmos-focus-node__tooltip');
  var tooltipNodeText = tooltipNode.append('text').attr('class', 'cosmos-focus-node__tooltip-text');

  function showAndPositionCrossHairs(xPosition, yPosition) {
    if (xPosition < 0 || xPosition > width || yPosition < 0 || yPosition > height) return;
    xCrossHair.attr('x1', xPosition).attr('y1', yScale(yDomain[0])).attr('x2', xPosition).attr('y2', yPosition).attr('display', null);
    yCrossHair.attr('y1', yPosition).attr('x1', xScale(xDomain[0])).attr('y2', yPosition).attr('x2', xPosition).attr('display', null);
  }

  function enlargeDotRadius(d) {
    svg.selectAll("#".concat(constructDotId(d))).attr('class', 'dot enlarged').style('stroke', 'white').style('fill-opacity', 0.9).attr('r', DOT_RADIUS_ENLARGED);
  }

  function shrinkAllEnlargedDotRadii() {
    svg.selectAll('.dot.enlarged').attr('class', 'dot').style('stroke', fillColorForDatum).style('fill-opacity', opacityForDatum).attr('r', DOT_RADIUS_NORMAL);
  }

  function hideCrossHairs() {
    xCrossHair.attr('display', 'none');
    yCrossHair.attr('display', 'none');
  }

  function onDotMouseOver(d) {
    var nodePositionX = xMap(d);
    var nodePositionY = yMap(d);
    showAndPositionCrossHairs(nodePositionX, nodePositionY);
    enlargeDotRadius(d);
    tooltipNode.attr('transform', "translate(".concat(nodePositionX, ",").concat(nodePositionY, ")")).attr('display', null);
    tooltipNodeText.style('text-anchor', 'start').attr('x', TOOLTIP_X_MARGIN).attr('y', -TOOLTIP_Y_MARGIN).text([_toInteger(xValue(d)), ' ', yAxisLabel, ', ', _toInteger(yValue(d)), ' ', yAxisLabel].join(''));
    var textBBox = tooltipNodeText[0][0].getBBox();

    if (nodePositionX + TOOLTIP_X_MARGIN + textBBox.width + TOOLTIP_SIDE_PADDING * 2 >= width) {
      tooltipNodeText.style('text-anchor', 'end').attr('x', -TOOLTIP_X_MARGIN);
      textBBox = tooltipNodeText[0][0].getBBox();
    }

    if (nodePositionY < height / 4) {
      tooltipNodeText.attr('y', TOOLTIP_Y_MARGIN + textBBox.height);
      textBBox = tooltipNodeText[0][0].getBBox();
    }

    tooltipNodeRect.attr('stroke', fillColorForDatum(d)).attr('width', textBBox.width + TOOLTIP_SIDE_PADDING * 2).attr('height', textBBox.height + TOOLTIP_TOP_BOTTOM_PADDING * 2).attr('x', textBBox.x - TOOLTIP_SIDE_PADDING).attr('y', textBBox.y - TOOLTIP_TOP_BOTTOM_PADDING);
  }

  function onDotMouseOut() {
    tooltipNode.attr('display', 'none');
    hideCrossHairs();
    shrinkAllEnlargedDotRadii();
  }

  function constructDotId(d) {
    return ['dot', _toInteger(xValue(d)), _toInteger(yValue(d))].join('-');
  }
}; // This function adjusts the python variable names to more readable names
// For example, the variable hydro_pred turns into Hydro (Predicted)


function fixLabel(label) {
  if (label.indexOf('_pred') > -1) {
    label = label.replace('_pred', ' (Predicted)');
  }

  label = label.replace('_', ' ');
  label = label.charAt(0).toUpperCase() + label.substring(1);
  return label;
}